import { render, staticRenderFns } from "./textOverflow.vue?vue&type=template&id=78b7147a&scoped=true"
import script from "./textOverflow.vue?vue&type=script&lang=js"
export * from "./textOverflow.vue?vue&type=script&lang=js"
import style0 from "./textOverflow.vue?vue&type=style&index=0&id=78b7147a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7147a",
  null
  
)

export default component.exports